@for (change of changes; track change) {
  <li>{{ change.field_name | translate }}: @if (change.old) {
    <span
    {{ change.old }} -> </span>
    } <span
  [style.color]="change.old ? null : 'green'">{{ change.new }}</span></li>
}
